import {ButtonStyles, RecipeCarouselV2Cta} from '@mfb/lego';

import {mfbScrollSmooth} from '../../../components/MFBScroll';
import ActionButtonContentModel from '../../actionButton/ActionButtonContentModel';
import {getContentfulLink} from '../../link/LinkContentModel';

const toButtonStyle = (buttonType?: string) =>
  buttonType === 'Secondary' ? ButtonStyles.Secondary : ButtonStyles.Primary;

export const mapRecipeCarouselV2Cta = (
  model: ActionButtonContentModel | undefined,
  navigate: (url: string) => void
): RecipeCarouselV2Cta | undefined => {
  if (!model) {
    return undefined;
  }

  const url = getContentfulLink(model.link);
  const scrollTarget = model.scrollTarget && model.scrollTarget.id;

  return {
    label: model.label,
    buttonStyle: toButtonStyle(model.buttonType),
    onClick: () => {
      if (scrollTarget) {
        mfbScrollSmooth(scrollTarget);
      } else if (url) {
        navigate(url);
      }
    },
  };
};
